import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen flex items-end justify-start overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5edf58d6b647cf2ebfe03e1d7e8412d4.jpg"
          alt="岡山のジュエリーおかやま - オーダーメイドジュエリー"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-left px-6 w-full max-w-2xl pb-20 lg:pb-28 lg:pl-16">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brown-700 mb-6 leading-tight">
          岡山で紡ぐ、<br />あなただけの物語
        </h2>
        <p className="text-xl md:text-2xl lg:text-3xl font-serif text-brown-600 mb-12">
          オーダーメイド・リメイク・<br />ブライダルジュエリー専門店
        </p>
        
        <div className="flex flex-col sm:flex-row items-start justify-start gap-4 mb-8">
          <Link
            to="/contact"
            className="w-full sm:w-auto px-8 py-4 bg-brown-400 text-white rounded-lg hover:bg-brown-500 transition-all font-serif text-lg shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            オーダーメイドを相談する
          </Link>
          <Link
            to="/shop"
            className="w-full sm:w-auto px-8 py-4 bg-white border-2 border-brown-400 text-brown-600 rounded-lg hover:bg-cream-100 transition-all font-serif text-lg shadow-lg whitespace-nowrap cursor-pointer"
          >
            商品一覧を見る
          </Link>
        </div>
        
        <p className="text-sm md:text-base text-brown-600 font-serif">
          営業時間 9:00-18:00 / 定休日：土曜・祝日
        </p>
      </div>
    </section>
  );
}